import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";

const colors = [
  "#3B82F6",
  "#ff002b",
  "#02865a",
  "#F59E0B",
  "#8B5CF6",
  "#3eb1c5",
  "#9b0b53",
  "#80d107",
  "#003c58",
  "#F97316",
];

const transformData = (data) => {
  const grouped = {};
  data.forEach(({ fornecedor, unidade, total }) => {
    if (!grouped[unidade]) grouped[unidade] = { unidade };
    grouped[unidade][fornecedor] = (grouped[unidade][fornecedor] || 0) + total;
  });
  return Object.values(grouped);
};

const RankingFornecedoresPorUnidadeChart = ({ data = [], height = 420 }) => {
  const chartData = transformData(data);
  const fornecedores = [...new Set(data.map((d) => d.fornecedor))];

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={chartData}
        barGap={4}
        barCategoryGap="25%"
        margin={{ top: 30, right: 40, bottom: 70, left: 20 }}
        barSize={30}
        animationDuration={700}
        animationEasing="ease-out"
      >
        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
        <XAxis
          dataKey="unidade"
          tick={{ fontSize: 12 }}
          interval={0}
          angle={-25}
          textAnchor="end"
          height={70}
        />
        <YAxis />
        <Tooltip
          formatter={(value, name) => [`${value} NCEs`, name]}
          labelFormatter={(label) => `Unidade: ${label}`}
          contentStyle={{
            fontSize: 12,
            borderRadius: 8,
            border: "1px solid #ddd",
            backgroundColor: "#fff",
          }}
        />
        {/* <Legend
          wrapperStyle={{
            fontSize: 12,
            marginTop: 60,
          }}
        /> */}
        {fornecedores.map((f, i) => (
          <Bar
            key={f}
            dataKey={f}
            fill={colors[i % colors.length]}
            name={f}
            radius={[4, 4, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RankingFornecedoresPorUnidadeChart;
